import { BookOpenText } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useI18n } from "@/contexts/I18nContext";

/**
 * Bilingual scripture card. Currently displays Hebrews 13:8 — the verse text is
 * read from the i18n dictionary so the language toggle works automatically.
 */
export function VerseCard() {
  const { t } = useI18n();
  return (
    <Card
      className="relative overflow-hidden rounded-2xl ring-1 ring-primary/15 shadow-sm"
      data-testid="home-verse-card"
    >
      <div
        className="absolute inset-0 -z-10 opacity-95"
        style={{
          background:
            "radial-gradient(620px circle at 90% 0%, rgba(200,30,58,0.10) 0%, transparent 55%), linear-gradient(180deg, hsl(var(--accent)) 0%, hsl(var(--card)) 100%)",
        }}
      />
      <CardContent className="flex items-start gap-3 p-4">
        <div className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
          <BookOpenText className="h-4 w-4" />
        </div>
        <div className="min-w-0">
          <p className="text-[11px] uppercase tracking-[0.18em] text-primary/80" data-testid="home-verse-ref">
            {t.home.verseRef}
          </p>
          <p
            className="font-serif-display mt-1 text-base leading-snug text-foreground/90 italic"
            data-testid="home-verse-text"
          >
            &ldquo;{t.home.verseText}&rdquo;
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
